var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui dropdown item" }, [
    _c("i", { staticClass: "translate icon" }),
    _vm._v(" "),
    !_vm.isMobile
      ? _c("span", [_vm._v("\n\t\t" + _vm._s(_vm.currentLanguage) + "\n\t")])
      : _vm._e(),
    _vm._v(" "),
    _c("i", { staticClass: "dropdown icon" }),
    _vm._v(" "),
    _c("div", { staticClass: "menu" }, [
      _c(
        "a",
        {
          staticClass: "item",
          on: {
            click: function($event) {
              return _vm.selectLanguage("en")
            }
          }
        },
        [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.$t("components.languageselector.languages.english")) +
              "\n\t\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "item",
          on: {
            click: function($event) {
              return _vm.selectLanguage("da")
            }
          }
        },
        [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.$t("components.languageselector.languages.danish")) +
              "\n\t\t"
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69f4d3dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69f4d3dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/LanguageSelector.vue
// module id = ex+q
// module chunks = 1